<script>
  import { createEventDispatcher } from 'svelte';
  import Field from './Field.svelte';

  export let label;
  export let options = [];
  export let value;
  export let isRequired = false;

  const dispatch = createEventDispatcher();
</script>

<Field {label} {isRequired}>
  <div class="select is-fullwidth">
    <select on:input={e => dispatch('input', { value: e.target.value })} {value}>
      <option value="" disabled>Unknown</option>
      {#each options as option}
        <option value={option}>{option}</option>
      {/each}
    </select>
  </div>
</Field>
